import { gql } from "@apollo/client";
import {
  ApplicantModel,
  FollowingQuestionsModel,
  HouseholdMemberServerModel,
  SecurityQuestionsModel,
} from "models";

interface SignModelServer {
  renewalTaxReturnConsent: boolean;
  renewalTaxReturnConsentYears: number;
}

export interface CREATE_ENROLLMENT_vars {
  enrollmentData: {
    sameAnnualIncome?: boolean;
    householdRelationships?: string | null;
    applicant: ApplicantModel;
    householdMembers: HouseholdMemberServerModel[];
    followingQuestions: FollowingQuestionsModel | null;
    securityQuestions: SecurityQuestionsModel | null;
    sign: SignModelServer | null;
    assister?: null;
  };
}

export interface CREATE_ENROLLMENT_data {
  createEnrollment: {
    success: boolean;
    message: string;
    caseAccessId: string;
  };
}

export const CREATE_ENROLLMENT = gql`
  mutation createEnrollment($enrollmentData: EnrollmentInput!) {
    createEnrollment(enrollmentData: $enrollmentData) {
      success
      message
      caseAccessId
    }
  }
`;
